import React, {useState, useMemo} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik"
import Grid from '@mui/material/Grid';
import useSafeState from '../../../../../useSafeState'; 
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextInput from '../../../../../components/Forms/TextInput';
import ButtonForm from "../../../../../components/Button/ButtonForm";
//import TableComp from '../../../../../components/Table/TableComp';
import Alert from "@mui/material/Alert";
import Button from '@mui/material/Button';
import { FILTER_VARIANTS } from "../../../../../constants";
import CustomDialog from '../../../../../components/Dialog/DiaComp';
import TableCard from '../../../../../components/Table/TableCard';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ButtonGeneRed from '../../../../../components/Button/ButtonGeneRed'
import { useTheme } from "@mui/material";
import ButtonGeneGrey from '../../../../../components/Button/ButtonGeneGrey';
import TextCardPipe from '../../../../../components/TextComps/TextCardPipe';


export function GetGeneTable() {

  const theme = useTheme();

  const navigate = useNavigate();
  
  const [search, setSearch] = useState('SYMBOL');

  const [value, setValue] = useSafeState({});
  const [data, setData] = useState(useMemo(() => []));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
    
  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true);};
  const handleClose = () => {setOpen(false);};

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

       
  const handleSubmit = (values) => {
    //const gene_input = values.gene
    setLoading(true)
    axios.get(`${FILTER_VARIANTS}/?${search}=${values.gene}`)
    .then((response) => {
        const d = handleData(response.data)
        setData( d )
        setLoading(false)
        setValue({ key: 'value' }); // NO MEMORY LEAK
    })
    .catch(function (error) {
      //throw new Error(error)
      setError(error.toJSON());
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        //console.log(error.response.data, error.response.status);
        
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
        //console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        //console.log('Error', error.message);
      }
      //console.log(error.config);
      console.log("Error")
    })
  }
  
  

    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].SYMBOL,
                                            'col3': response[i].GeneName,
                                            'col4': response[i].MANE_SELECT,
                                            'col5': response[i].BIOTYPE,
                                            'col6': response[i].Uploaded_variation,
                                            'col7': response[i].chr_start,
                                            'col8': response[i].chr_end,
                                            'col9': response[i].HGVSg,
                                            'col10': response[i].HGVSp,
                                            'col11': response[i].EXON,
                                            'col12': response[i].INTRON,
                                            'col13': response[i].Consequence,
                                            'col14': response[i].VARIANT_CLASS,
                                            'col15': response[i].clinvarID,
                                            'col16': response[i].CLNSIG,
                                            'col17': response[i].CLNREVSTAT,
                                            'col18': response[i].RS,
                                            'col19': response[i].CLNDN,
                                            'col20': response[i].sample,
                                            'col21': response[i].owner,
                                      },
                                );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
        {
          header: 'Gene Name',
          accessorKey: 'col3',
          cell: info => info.getValue(),
          footer: props => props.column.id,
          },
          {
            header: 'Gene',
            accessorKey: 'col2',
            cell: info =>  <ButtonGeneGrey name = {info.getValue()} />, 
            footer: props => props.column.id,
            },
            {
              header: 'Phenotype',
              accessorKey: 'col19',
              cell: info => <TextCardPipe textcard={ info.getValue()} />,
              footer: props => props.column.id,
              },
              {
                accessorKey: 'col16',
                header: 'clinvar - Classification',
  //              header: () => <Typography component="span" variant="h6" sx={{color: "traffic.red"}}>'clinvar' CLASSIFICATION</Typography>,
                cell: info =>  info.getValue() === 'Pathogenic' ? <ButtonGeneRed name = {info.getValue()} /> : <ButtonGeneGrey name = {info.getValue()} />,
                footer: props => props.column.id,  
              },
              {
                header: 'Variant Type',
                accessorKey: 'col14',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                {
                  header: 'dbSNP',
                  accessorKey: 'col18',
                  cell: info => info.getValue(),
                  footer: props => props.column.id,
                  },
                
              {
                header: 'Exon Nr.',
                accessorKey: 'col11',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                
                    {
                      header: 'clinvar ID',
                      accessorKey: 'col15',
                      cell: info => info.getValue(),
                      footer: props => props.column.id,
                      },
                      {
                        header: 'HGVSg',
                        accessorKey: 'col9',
                        cell: info => info.getValue(),
                        footer: props => props.column.id,
                        },
                        {
                          header: 'HGVSp',
                          accessorKey: 'col10',
                          cell: info => info.getValue(),
                          footer: props => props.column.id,
                          },
      ],
      []
      )

return (
<>

{theme.palette.mode === "light" ? (

<Grid container>

      <Grid size={{xs:12, md:8}} sx={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label" sx={{mb:4, pl:4, mt:2 }}>
              <Typography variant="h4" sx={{color: 'common.black'}}>Select one of the 3 options:</Typography>
          </FormLabel>
          
          <RadioGroup defaultValue="SYMBOL" onChange={handleChange}  aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group"
                    sx={{mb:4, pl:4,  '& .MuiSvgIcon-root': {fontSize: 28, color: 'common.black',}, color: 'common.black', '&.Mui-checked': {color: 'common.black', }}} >
              <FormControlLabel value="SYMBOL" control={<Radio />} label="Find all my variants for a gene" />
              <FormControlLabel value="RS" control={<Radio />} label="Check a specific rs-number (dbSNP) in my genetic data" />
              <FormControlLabel value="clinvarID" control={<Radio />} label="Check a specific clinvar-ID in my genetic data" />
          </RadioGroup>
        
        </FormControl>
        
        </Grid>

    <Grid size={{xs:12, md:4}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-end'}}>

    <Formik
        enableReinitialize
        initialValues={{ gene: '' }}
        // validationSchema={validationRules} 
        onSubmit={(values, { setSubmitting }) => { 
            // same shape as initial values
            handleSubmit(values);
            setOpen(true);
            setSubmitting(false);  
          }}
      >
     
        <Form>
        
        <Box sx={{ '& > :not(style)': { m: 6, width: '28ch', },  }}>        
          <TextInput label="gene symbol, rs-number or clinvarID" name="gene" type="text" placeholder="enter one of the 3 options" bgcolor="background.default" />   
        </Box>
 
            <Box sx={{ '& > :not(style)': { m: 6, width: '28ch', },  }}>
               <ButtonForm name={ 'Submit' }  disabled={Formik.isSubmitting} />     
            </Box>
            
       
      </Form>
  </Formik>

  </Grid>
</Grid>

):(

  <Grid container>
  <Grid size={{xs:12, md:8}} sx={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label" sx={{mb:4, pl:4, mt:2 }}>
        <Typography variant="h4" sx={{color: 'common.white'}}>Select one of the 3 options:</Typography>
        </FormLabel>
        
        <RadioGroup defaultValue="SYMBOL" onChange={handleChange}  aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group"
                  sx={{mb:4, pl:4,  '& .MuiSvgIcon-root': {fontSize: 28, color: 'common.white',}, color: 'common.white', '&.Mui-checked': {color: 'common.white', }}} >
            <FormControlLabel value="SYMBOL" control={<Radio />} label="Find all my variants for a gene" />
            <FormControlLabel value="RS" control={<Radio />} label="Check a specific rs-number (dbSNP) in my genetic data" />
            <FormControlLabel value="clinvarID" control={<Radio />} label="Check a specific clinvar-ID in my genetic data" />
        </RadioGroup>
      </FormControl>
</Grid>
 <Grid size={{xs:12, md:4}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-end'}}>
     
<Formik
        enableReinitialize
        initialValues={{ gene: '' }}
        // validationSchema={validationRules} 
        onSubmit={(values, { setSubmitting }) => { 
            // same shape as initial values
            handleSubmit(values);
            setOpen(true);
            setSubmitting(false);  
          }}
      >
     
        <Form>
        
        <Box sx={{ '& > :not(style)': { m: 6, width: '28ch', },  }}>        
          <TextInput label="gene symbol, rs-number or clinvarID" name="gene" type="text" placeholder="enter one of the 3 options" bgcolor="background.default" />   
        </Box>
 
            <Box sx={{ '& > :not(style)': { m: 6, width: '28ch', },  }}>
               <ButtonForm name={ 'Submit' }  disabled={Formik.isSubmitting} />     
            </Box>
            
       
      </Form>
  </Formik>
  

</Grid>


</Grid>
)}

{error  ? (
            <Alert severity="error" sx={{mt:2}}>
                <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
                <Button variant="contained" onClick={() => { navigate("/", { replace: true }) }} sx={{mt:1, bgcolor: 'tertiary.dark', color:'common.white'}}> Try again </Button>
            </Alert>
            ) : (null)}



<div>

{ loading && <span> Please wait ... fetching data </span>}

      <CustomDialog open={open} onClose={handleClose}
                
                content = {<TableCard columns={columns} data={data} />}
       />

</div>

</>

);
}